<template>
  <div class="post type-post hentry">
    <h2>Krikščionių partija</h2>
    <div class="entry">
      <p>
        <a href="images/Sakiu_Skyrius_wordpress.jpg"></a
        ><a href="images/Sakiu_Skyrius_wordpress.jpg"
          ><img
            class="size-full wp-image-172 alignnone"
            title="Sakiu_Skyrius_wordpress"
            src="images/Sakiu_Skyrius_wordpress.jpg"
            alt=""
            width="550"
            height="378"
        /></a>
      </p>
      <p>
        <strong
          >Krikščionių partijos Šakių skyriaus kandidatų į Šakių rajono
          savivaldybės tarybą<br />
          SĄRAŠAS<br />(rinkiminis numeris 142)</strong
        >
      </p>
      <table style="width: 595px;">
        <tbody>
          <tr>
            <td>1.</td>
            <td style="width: 190px;">Romaldas Petras Damušis</td>
            <td>Advokatas</td>
          </tr>
          <tr>
            <td>2.</td>
            <td>Vincas Pulokas</td>
            <td>įmonės direktorius</td>
          </tr>
          <tr>
            <td>3.</td>
            <td>Daiva Dovydė</td>
            <td>MAMN-KC – prezidentė</td>
          </tr>
          <tr>
            <td>4.</td>
            <td>Saulius Urbaitis</td>
            <td>inžinierius</td>
          </tr>
          <tr>
            <td>5.</td>
            <td>Daiva Bublaitienė</td>
            <td>verslininkė</td>
          </tr>
          <tr>
            <td>6.</td>
            <td>Rima Prekevičienė</td>
            <td>kultūros darbuotoja</td>
          </tr>
          <tr>
            <td>7.</td>
            <td>Leonas Puidokas</td>
            <td>verslininkas</td>
          </tr>
          <tr>
            <td>8.</td>
            <td>Birutė Lukošienė</td>
            <td>buhalterė</td>
          </tr>
          <tr>
            <td>9.</td>
            <td>Antanas Sinkus</td>
            <td>inžinierius</td>
          </tr>
          <tr>
            <td>10.</td>
            <td>Vitalijus Bogovičius</td>
            <td>inžinierius</td>
          </tr>
          <tr>
            <td>11.</td>
            <td>Reda Konteikienė</td>
            <td>dėstytoja</td>
          </tr>
          <tr>
            <td>12.</td>
            <td>Edita Šakaitienė</td>
            <td>pedagogė</td>
          </tr>
          <tr>
            <td>13.</td>
            <td>Beniamina Tirlikienė</td>
            <td>auklėtoja</td>
          </tr>
        </tbody>
      </table>
      <p><em></em></p>
      <p>
        <strong
          >KP Šakių skyriaus rinkiminė<br />
          PROGRAMA
        </strong>
      </p>
      <p><strong>KP Šakių skyriaus veiklos prioritetai </strong></p>
      <p>
        Zanavykų vienybė – be susipriešinimo dėl turtinių skirtumų, politinių
        pažiūrų ir socialinės padėties.<br />
        Visuotinės gyventojų gerovės siekimas ir žemės ūkio sektoriaus
        plėtra.<br />
        Verslo bei ekonomikos, infrastruktūros plėtros skatinimas ir saugios
        aplinkos kūrimas.<br />
        Visuomenės švietimo, mokymo, sveikatingumo gerinimas, socialinio saugumo
        užtikrinimas.<br />
        Zanavykijos kultūrinio savitumo ir krašto patrauklumo puoselėjimas bei
        turizmo skatinimas.
      </p>
      <p><strong>KP Šakių skyriaus veiklos tikslai </strong></p>
      <p>
        Puoselėti krikščioniškas dvasines vertybes ir tautinės kultūros
        tradicijas, stiprinti pilietinę visuomenę su teisinga tvarka ir modernia
        savivalda, dirbti rajono žmonių labui, nutraukti sąstingį politiniame ir
        visuomeniniame gyvenime.<br />
        Didinti visuomeninių ir religinių bendruomenių įtaką savivaldybės ir jos
        padalinių sprendimams.<br />
        Skatinti vietinės ekonomikos plėtrą, privačią iniciatyvą, smulkų verslą
        ir kaimo amatus.<br />
        Išsaugoti esamas darbo vietas, šalinti jų mažėjimo priežastis, skatinti
        dirbančių užsienyje asmenų grįžimą, mažinti emigraciją.<br />
        Palaikyti ir skatinti verslininkus, ūkininkus, amatininkus, kuriančius
        naujas darbo vietas.<br />
        Sudaryti galimybes daugiabučių namų modernizavimui.<br />
        Siekti skaidraus, teisėto ir efektyvaus savivaldybės biudžeto bei
        užsienio fondų lėšų panaudojimo pagal numatytus prioritetus ir
        užtikrinti griežtą jų panaudojimo kontrolę.<br />
        Siekti, kad savivaldybė ir jos įmonės vengtų nepagrįstų ir rizikingų
        kreditų bei paskolų.<br />
        Reikalauti skaidrumo organizuojant savivaldybės konkursus.<br />
        Užkirsti kelią neskaidriam viešųjų pirkimų organizavimui, užtikrinti
        lygiateisiškumo bei konkurencijos principus, siekti sumažinti paslaugų
        ir darbų kainas.<br />
        Išspręsti dirbtinai sukeltas atliekų tvarkymo problemas, peržiūrėti
        vietinės rinkliavos už atliekų išvežimą kainodarą ir ją kvalifikuotai
        sureguliuoti.<br />
        Organizuoti optimalų gyventojų aptarnavimą viešuoju transportu.<br />
        Išsiaiškinti vandens, kanalizavimo, šilumos ir karšto vandens įkainių
        nustatymo pagrįstumą, siekti principingai įvertinti šias paslaugas
        teikiančių įmonių veiklą ir rasti būdus įkainių mažinimui.<br />
        Individualizuoti socialinių pašalpų skyrimą: šalpos būtinybė ir dydžiai
        turi būti nustatomi pagal esamas galimybes bei reikalingumą.<br />
        Plėsti socialinių paslaugų tiekimą pagyvenusiems žmonėms ir asmenims su
        negalia.<br />
        Mažinti darbingų socialiai remtinų gyventojų skaičių rajone.<br />
        Stiprinti švietimo, kultūros ir medicinos įstaigų materialinę bazę ir
        sustabdyti jų naikinimo procesą.<br />
        Principingai vertinti tarnybines pareigas, moralę ir etiką
        pažeidžiančius asmenis. Šalinti korupcijos ir biurokratizmo priežastis.
      </p>
    </div>
  </div>
</template>
